import { JetView } from 'webix-jet';
import Filters from 'views/agent/configuration/securityChanges/filter';
import Table from 'views/agent/configuration/securityChanges/table';
import { devConfig } from 'config/config';

/**
 * Represents the view for security changes.
 * Extends the JetView class from webix-jet.
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view for security changes.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const theme = this.app.config.theme;
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(),
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar',
                    css: theme,
                    elements: [{ view: 'label', label: _('QR'), width: 150 }],
                },
                {
                    view: 'template',
                    id: 'templateQR',
                    onClick: {
                        /**
                         * Copies the QR text to the clipboard.
                         * @param {Event} ev - The click event.
                         * @param {string} id - The id of the clicked element.
                         */
                        copy_text: function (ev, id) {
                            var copyText = document.getElementById('lname');
                            copyText.select();
                            copyText.setSelectionRange(0, 99999);
                            document.execCommand('copy');
                            webix.message(_('QR Copiado!'));
                        },
                    },
                },
                {
                    view: 'label',
                    label: _('No tienes un QR Configurado.'),
                    localId: 'label',
                    id: 'labelError',
                },
            ],
        };
        if (!devConfig.getPermAction('AgentConfigurationQrgoogleMenu', 'Menu')) {
            this.show('../');
        } else {
            return {
                type: 'wide',
                cols: [left],
            };
        }
    }

    /**
     * Initializes the view and sets up the QR code display.
     */
    init() {
        const cur_user = this.getParam('user', true);
        $$('labelError').hide();
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetQRGoogle', 'id=' + cur_user, {
            error: function (text, data, XmlHttpRequest) {
                webix.message('Error! ');
            },
            success: function (text, data, XmlHttpRequest) {
                var text = JSON.parse(text);
                if (!text.HasError) {
                    $$('templateQR').show();
                    $$('labelError').hide();
                    $$('templateQR').setHTML(
                        `<div style="text-align: center;">
	                            <img style="display:inline-block" src="` +
                            text.data +
                            `">
	                        </div>
	                        <br>
	                        <div style="text-align: center;">
	                            <input type="text" id="lname" name="lname"
	                                style="width: 50%;
	                                padding: 12px 20px;
	                                margin: 8px 0;
	                                display: inline-block;
	                                border: 1px solid #ccc;
	                                border-radius: 4px;
	                                box-sizing: border-box;
	                                text-align: center;"
	                                value="` +
                            text.text +
                            `">
	                            <button class='button-login copy_text'
	                                style="
	                                background-color: #263043 !important;
	                                color: white;
	                                padding: 14px 20px;
	                                margin: 8px 0;
	                                border: none;
	                                border-radius: 4px;
	                                cursor: pointer;"><span class="icon-copy"></span></button>
	                        </div>`,
                    );
                } else {
                    $$('templateQR').hide();
                    $$('labelError').show();
                }
            },
        });
    }
}

// FILE DOCUMENTED
